import React, { Component } from 'react';
import HelpIcon from '@mui/icons-material/Help';
class KnowledgeBase extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const p = this.props
        return (
            <div className="d-flex align-items-center ml-1">
                <a href={p.link} target="_blank" className="link_default" title="Click to view details">
                    <HelpIcon className="green-text glyphicon glyphicon-question-sign font-18px" />
                </a>
            </div>
        )
    }
}

export default KnowledgeBase;